import React from 'react'
import FAQ from "../assets/img/faq/01.jpg"

function FAQsArea() {
  return (
    <div className="testimonial-area faq-area py-120">
        <div className="container">
            <div className="row">
                <div className="col-lg-6">
                    <div className="faq-right">
                        <div className="site-heading mb-3">
                            <span className="site-title-tagline justify-content-start">FAQs</span>
                            <h2 className="site-title text-white my-3">Your Questions, <span>Answered</span></h2>
                        </div>
                        <p className="about-text text-white">
                            At ServiSwift, we understand the importance of clarity and transparency. Below, we’ve compiled answers to the most common questions from our customers to help you navigate our services with ease.
                        </p>
                        <div className="faq-img mt-3">
                            <img src={FAQ} alt="FAQs Imagse" />
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="accordion" id="accordionExample">
                        
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                                <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <span><i className="far fa-question"></i></span> How long does it take to book a ride?
                                </button>
                            </h2>
                            <div id="collapseOne" className="accordion-collapse collapse show"
                                aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    Booking a ride with ServiSwift is quick and seamless. Using our app or website, you can book a ride in under a minute. Simply select your pick-up and drop-off locations, and we’ll handle the rest!
                                </div>
                            </div>
                        </div>

                        
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <span><i className="far fa-question"></i></span> How can I become a registered service provider?
                                </button>
                            </h2>
                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo"
                                data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    To join ServiSwift as a service provider, visit our website and navigate to the "Join Us" section. Complete the registration form, upload the required documents, and our team will review your application within 48 hours.
                                </div>
                            </div>
                        </div>

                        
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingThree">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    <span><i className="far fa-question"></i></span> What payment options are available?
                                </button>
                            </h2>
                            <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree"
                                data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    We support a variety of payment options, including mobile money (Airtel Money, Mpamba), credit/debit cards, and cash on delivery. Our aim is to ensure convenient payment for all users.
                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFour">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <span><i className="far fa-question"></i></span> How do I cancel my booking?
                                </button>
                            </h2>
                            <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour"
                                data-bs-parent="#accordionExample">
                                <div className="accordion-body">
                                    You can cancel your booking via the app or website before the service begins. Simply go to the "My Bookings" section, select the active booking, and click "Cancel." Cancellation fees may apply based on our terms and conditions.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default FAQsArea